import { Component, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription, from, max } from 'rxjs';
import * as AuthActions from 'src/app/store/auth/auth.actions';
import { AppComponent } from 'src/app/app.component';
import { AppState } from 'src/app/store/app.reducer';
import { selectExitBeta, selectNotificationMaintenance, selectUser, selectUserBetaFe } from 'src/app/store/user/user.selector';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/model/user';
import { Role } from 'src/app/model/role';
import { selectTopbarTitle } from 'src/app/store/notifications/notifications.selector';
import { NotificationMaintenance } from 'src/app/model/notification-maintenance';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { LOCALSTORAGE_NOTIFICATION_MAINTENANCE_ID } from 'src/app/conf/user';
import { environment } from 'src/environments/environment';
import * as UserActions from 'src/app/store/user/user.actions';
import { selectAuthCodeData } from 'src/app/store/auth/auth.selector';
import { TokenData } from 'src/app/model/api/token-data';
import { AppMainComponent } from 'src/app/menu/app.main.component';
import { NotificationMaintenanceDialogComponent } from 'src/app/components/home/components/notification-maintenance-dialog/notification-maintenance.dialog.component';
import { StandardPageLayout } from '../../stdlayoutlib/classes.stdlayoutlib';
import { selectStatusData } from 'src/app/store/task/task.selector';
import { StatusData } from 'src/app/model/api/data-rest';

@Component({
	selector: 'app-common-topbar',
	templateUrl: './common.topbar.component.html',
	providers: [DialogService, AppMainComponent],
	// providers: [DialogService, AppMainComponent, CameServiceComponent, TechnicianComponent],
})
export class CommonTopBarComponent implements OnInit, OnDestroy {
	// Observables and subscriptions
	titleSel$: Observable<string>;
	titleSub: Subscription | undefined;
	userBetaFeSel$: Observable<number | undefined>;
	userBetaFeSelSub: Subscription | undefined;

	notificationMaintenance?: NotificationMaintenance[];
	notificationMaintenance$: Observable<NotificationMaintenance[]>;
	notificationMaintenanceSub?: Subscription;
	tokenData$: Observable<TokenData | undefined>;
	tokenDataSub: Subscription | undefined;
	exitBeta$: Observable<boolean | undefined>;
	exitBetaSub: Subscription | undefined;

	statusMaintanance$: Observable<StatusData | undefined>;
	statusMaintananceSub: Subscription | undefined;

	betaFe: number;
	titleId = '';
	tokenData?: TokenData;

	currentUser?: User;
	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;
	currentRole?: Role;

	screenWidth: number;

	showInfoAvatar: boolean;
	dynamicTitle: string;

	ref: DynamicDialogRef | undefined;

	enableBeta: boolean = false;

	constructor(
		public app: AppComponent,
		public appMain: AppMainComponent,
		// private serviceMain: CameServiceComponent,
		// private techMain: TechnicianComponent,
		private store: Store<AppState>,
		private router: Router,
		private route: ActivatedRoute,
		public dialogService: DialogService,
		private translate: TranslateService,
		public renderer: Renderer2,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.onResize();
	}

	getMain(profile): boolean {
		switch (this.currentRole.Description) {
			/* case "TECHNICIAN":
				return this.techMain.activeTopbarItem === profile;
			case "SERVICE":
				return this.serviceMain.activeTopbarItem === profile; */
			/* case "MARKETING":
				return this.marketMain.activeTopbarItem === profile; */
			default:
				return this.appMain.activeTopbarItem === profile;
		}

	}

	onTopbarItemClick($event, profile) {
		switch (this.currentRole.Description) {
			/* case "TECHNICIAN":
				return this.techMain.onTopbarItemClick($event,profile);
			case "SERVICE":
				return this.serviceMain.onTopbarItemClick($event,profile); */
			/* case "MARKETING":
				return this.marketMain.activeTopbarItem === profile; */
			default:
				return this.appMain.onTopbarItemClick($event, profile);
		}
	}

	ngOnDestroy(): void {
		this.userSub?.unsubscribe();
		this.userBetaFeSelSub?.unsubscribe();
		this.titleSub?.unsubscribe();
		this.notificationMaintenanceSub?.unsubscribe();
		this.tokenDataSub?.unsubscribe();
		this.exitBetaSub?.unsubscribe();
		this.statusMaintananceSub?.unsubscribe();
	}

	initSelectors(): void {
		// Store selectors
		this.user$ = this.store.select(selectUser);
		this.userBetaFeSel$ = this.store.select(selectUserBetaFe);
		this.titleSel$ = this.store.select(selectTopbarTitle);
		this.notificationMaintenance$ = this.store.select(selectNotificationMaintenance);
		this.tokenData$ = this.store.select(selectAuthCodeData);
		this.exitBeta$ = this.store.select(selectExitBeta);
		this.statusMaintanance$ = this.store.select(selectStatusData);
	}

	subscribeAll(): void {
		this.statusMaintananceSub = this.statusMaintanance$.subscribe(statusData => {
			if (statusData !== undefined && statusData !== null && statusData.Status !== undefined && statusData.Status > 0) {
				this.logout();
			}
		});
		this.userSub = this.user$?.subscribe(currentUser => {
			this.currentUser = currentUser;
			if (currentUser.JumpFe) {
				this.enableBeta = true;
			}
			const roles = currentUser?.Roles;
			if (roles && roles.length > 0) {
				this.currentRole = roles[0];
			}
		});
		this.userBetaFeSelSub = this.userBetaFeSel$?.subscribe(
			(betaFe: number) => {
				this.betaFe = betaFe;
				/*if (this.betaFe === 0) {//TODO NOT USE ANYMORE
					this.logout();
				}*/
			}
		);
		this.titleSub = this.titleSel$.subscribe(
			(title: string) => {
				this.titleId = title;
			}
		);
		this.tokenDataSub = this.tokenData$.subscribe(tokenData => {
			this.tokenData = tokenData;
		});
		this.exitBetaSub = this.exitBeta$.subscribe(exitBeta => {
			if (exitBeta) {
				window.open(environment.oldFrontEnd + '/login?br=' + this.tokenData.access_token +
					'&ex=' + this.tokenData.expires_in.toString(), '_self');
			}
		});
		this.notificationMaintenanceSub = this.notificationMaintenance$
			.subscribe(notificationMaintenance => {
				this.notificationMaintenance = notificationMaintenance;
				if (notificationMaintenance && notificationMaintenance.length > 0) {
					const notificationIdStorage = localStorage.getItem(LOCALSTORAGE_NOTIFICATION_MAINTENANCE_ID);
					const ab = from(notificationMaintenance.map(notification => notification.NotificationId)).pipe(max((a, b) => a - b));
					ab.subscribe(maxId => {
						/* if (notificationIdStorage) {
							const notificationId = parseInt(notificationIdStorage, 10);
							if (notificationId < maxId){
								this.viewNotificationMaintenance();
							}
						} else {
							this.viewNotificationMaintenance();
						} */
					});
				}
			}
			);
	}

	iconNotificationMaintenance(): boolean {
		return !!this.notificationMaintenance && this.notificationMaintenance.length > 0;
	}

	viewNotificationMaintenance(): void {
		this.ref = this.dialogService.open(NotificationMaintenanceDialogComponent, {
			header: this.translate.instant('SYSTEM_NOTIFICATION'),
			width: '70vw',
			breakpoints: { '1120px': '98vw' },
			contentStyle: { overflow: 'auto' },
			closable: false,
		});
	}

	getCurrentRole(): string {
		return (this.currentRole) ? this.translate.instant(this.currentRole.Description) : '';
	}

	truncateString(str: string, num: number): string {
		if (str.length > num) {
			return str.slice(0, num) + "...";
		} else {
			return str;
		}
	}

	getUsername(): string {
		switch (this.currentRole.Description) {
			case "MARKETING":
				return "CAME MARKETING";
			case "SERVICE":
				return "CAME SERVICE";
			case "TECHNICIAN":
				return this.truncateString(this.currentUser.FirstName + ' ' + this.currentUser.LastName, 26);
			default:
				return "User";
		}
	}

	getProfileStdStr(): string {
		switch (this.currentRole.Description) {
			case "TECHNICIAN":
				return this.translate.instant('TECHNICIAN_PROFILE');
			default:
				return "";
		}
	}

	showNotificationList(): boolean {
		switch (this.currentRole.Description) {
			case "MARKETING":
				return false;
			case "SERVICE":
				return false;
			case "TECHNICIAN":
				return true;
			default:
				return false;
		}
	}

	showUserProfile(): boolean {
		switch (this.currentRole.Description) {
			case "MARKETING":
				return false;
			case "SERVICE":
				return false;
			case "TECHNICIAN":
				return true;
			default:
				return false;
		}
	}

	userProfile(): void {
		this.router.navigate([`/${this.route.snapshot.routeConfig.path}`, 'profile']);
	}

	logout(): void {
		this.store.dispatch(AuthActions.authLogout());
	}

	/*goToOldCameConnect(): void { //TOREMOVE in futuro
		if (!this.enableBeta) {
			const user: User = {
				...this.currentUser,
				JumpFe: 0,
			};
			this.store.dispatch(UserActions.updateCurrentUserExitBeta({ user }));
		}
	}*/

	getMenuTheme(): string {
		return this.app.menuTheme;
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
		this.setTopbar();
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	setTopbar() {
		if (StandardPageLayout.underTablet(this.screenWidth)) {
			this.showInfoAvatar = false;
			this.dynamicTitle = "ml-6";
		} else {
			this.showInfoAvatar = true;
			this.dynamicTitle = "ml-7";
		}
	}
}
